<template>
    <div class="c-wrapper">
        <h5 class="c-title">{{data.title}}</h5>
        <div class="c-cont-wrap">
            <template v-for="(item, index) in data.list">
                <!--段落-->
                <p v-if=" item.type == 'p' " :key="index" class="c-wrap-row">{{item.desc}}</p>
                <!--有序号列表-->
                <ol v-if=" item.type == 'ol' " :key="index" class="c-wrap-ol">
                    <li v-for="(itemol, indexol) in item.list" :key="indexol" class="c-wrap-ol-li">{{itemol.desc}}</li>
                </ol>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "cellPreface",
    props: [ 'wrapData' ],
    watch: {
        wrapData(val) {
            // console.log(val)
        }
    },
    computed: {
        data() {
            return this.wrapData;
        },
    },
    methods: {

    },
    created() {
        // console.log('cellGlossary wrapData: ' + JSON.stringify(this.data))
    },
}
</script>

<style scoped>
/** 当前 1rem = 28px */
.c-wrapper { margin-bottom: 1rem; }
.c-title { font-size: .5rem; text-align: center; margin-bottom: 0.5rem; }
</style>



// WEBPACK FOOTER //
// src/components/cell-preface.vue